/**
 * Base configuration properties.
 *
 * This file should be version-controlled and contain the configuration
 * properties.
 *
 * @class config-base
 * @module Config
 * @static
 */
declare var globalConfig;

export class EpitConfig implements Config {
    constructor() {
        Object.keys(globalConfig)
            .forEach((key) => this[key] = globalConfig[key]);
    }

    runmodes = {development: 'development', test: 'test', live: 'live'};
    runmode;

    uiVersion;

    /**
     * Is debug-mode enabled.
     *
     * @property debug
     * @type Boolean
     */
    debug;

    /**
     * Default language.
     *
     * @property language
     * @type String
     */
    language = 'et';

    /**
     * Base url under which eservice ui service endpoints are expected to be mapped.
     */
    apiUrl = globalConfig.apiUrl;
    baseUrl = globalConfig.baseUrl;
    securityUrl = globalConfig.securityUrl;
    casUrl = globalConfig.casUrl;
    appVersion = globalConfig.appVersion;
    roleRequestTimeout = globalConfig.roleRequestTimeout;
}

export let config = new EpitConfig();
//TODO: legacy fallback to default... remove once references have been qualified
export default config;


// WEBPACK FOOTER //
// ./src/ui/core/application/Config.ts